<template>
  <ul
    class="child-menu"
    v-if="menus && menus.length > 0"
    :style="{ '--left-val': left, '--top-val': top }"
  >
    <li class="child-li" v-for="menu in menus" :key="menu.id">
      <template v-if="menu.object === 'custom'">
        <a
          :title="menu.title"
          class="nav-link link-hover"
          v-if="menu.url && menu.url != ''"
          :href="menu.url"
          >{{ menu.title }}</a
        >
        <template v-else>
          <span class="link-hover">{{ menu.title }}</span>
        </template>
      </template>
      <template v-else>
        <template v-if="$root.enable_piwik_reload">
          <a
            :title="menu.title"
            :href="
              getRouteLink(menu.slug, menu.object, menu.base_slug, menu.url)
            "
            class="nav-link link-hover"
            >{{ menu.title }}</a
          >
        </template>
        <template v-else>
          <router-link
            :title="menu.title"
            tag="a"
            :to="getRouteLink(menu.slug, menu.object, menu.base_slug, menu.url)"
            class="nav-link link-hover"
            >{{ menu.title }}</router-link
          >
        </template>
      </template>
      <span class="arrow-left" v-if="menu.children && menu.children.length > 0">
        <svg
          width="6"
          height="9"
          viewBox="0 0 6 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.0078125 7.93875L3.44656 4.5L0.0078125 1.06125L1.06906 0L5.56906 4.5L1.06906
                    9L0.0078125 7.93875Z"
            fill="#333333"
          />
        </svg>
      </span>
      <template v-if="menu.children && menu.children.length > 0">
        <ChildMenu :menus="menu.children" left="100%" top="0%" />
      </template>
    </li>
  </ul>
</template>

<script>
import ChildMenu from "./ChildMenu";

export default {
  name: "ChildMenu",
  props: ["menus", "left", "top"],
  components: {
    ChildMenu,
  },
  mounted: function () {
    // var that = this;
    // var childLi = document.querySelectorAll(".child-li");
    // childLi.forEach((ele) =>
    //   ele.addEventListener("mouseenter", function (event) {
    //     console.log("mouse-enter");
    //     //that.showChild(event);
    //     let childMenu = event.target.querySelector(".child-menu");
    //     if (childMenu) {
    //       childMenu.classList.add("child-menu-open");
    //     }
    //   })
    // );
    // childLi.forEach((ele) =>
    //   ele.addEventListener("mouseleave", function (event) {
    //     console.log("mouse-leave");
    //     //that.hideChild(event);
    //     let childMenu = event.target.querySelector(".child-menu");
    //     if (childMenu) {
    //       childMenu.classList.remove("child-menu-open");
    //     }
    //   })
    // );
  },
  methods: {
    // showChild: function (event) {
    //   let childMenu = event.target.querySelector(".child-menu");
    //   if (childMenu) {
    //     childMenu.style.visibility = "visible";
    //     childMenu.style.opacity = 1;
    //   }
    // },
    // hideChild: function (event) {
    //   let childMenu = event.target.querySelector(".child-menu");
    //   if (childMenu) {
    //     childMenu.style.visibility = "hidden";
    //     childMenu.style.opacity = 0;
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.arrow-left {
  float: right;
  padding-left: 4px;
}

.child-menu {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
  right: 105%;
  left: var(--left-val) !important;
  top: var(--top-val);
  padding: 0px 10px;
  min-width: 240px;
  min-width: max-content;
  min-width: -moz-max-content;
  min-width: -webkit-max-content;
  min-width: -o-max-content;
  height: inherit;
  box-sizing: border-box;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
  margin: 0;
  background-color: @white;
  transition: 0.5s;
  li {
    background-color: @white !important;
    padding: 0px 10px;
    padding-bottom: 28px;
    position: relative;
    a {
      color: #222222 !important;
      padding: 0 !important;
      border-bottom: none !important;
      margin: 0;
      font-size: 15px;
      font-weight: 300;
      margin-right: 10px;
    }
    span {
      color: #222222 !important;
      padding: 0 !important;
      border-bottom: none !important;
      margin: 0;
      font-size: 15px;
      font-weight: 300;
    }
    &:first-child {
      padding-top: 16px;
    }
    &:last-child {
      padding-bottom: 16px;
    }
  }
}

.child-menu-open {
  visibility: visible;
  opacity: 1;
}
.cssmenu>ul>li:nth-last-child(2) ul.child-menu li ul li {
  max-width: 140px;
}
</style>


// WEBPACK FOOTER //
// src/components/ui/ChildMenu.vue